import { createFileRoute } from '@tanstack/react-router'
import { loaderSeason } from '~/features/compensation/queries'
import { FeesPage } from '~/features/finance/FeesPage'
import { NoFinanceAccess } from '~/features/finance/parts'
import { chargesQuery, overviewQuery, plansQuery } from '~/features/finance/queries'
import { useCan } from '~/lib/session'

export const Route = createFileRoute('/_app/verein/finanzen/')({
  loader: async ({ context }) => {
    const s = await loaderSeason(context.queryClient)
    if (!s?.canRead) return
    const qc = context.queryClient
    await Promise.all([qc.ensureQueryData(overviewQuery(s.season)), qc.ensureQueryData(plansQuery()), qc.ensureInfiniteQueryData(chargesQuery(s.season, { status: 'outstanding' }))])
  },
  component: function Finanzen() {
    return useCan()('finance.read') ? <FeesPage /> : <NoFinanceAccess title="Finanzen" />
  },
})
